
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.777 35.21H4V12.603h9.47c.283 0 .545-.161.735-.37.189-.209.275-.529.248-.81v-1.395c0-.567.461-1.028 1.028-1.028h13.816c.567 0 1.028.461 1.028 1.028l-.001 1.374-.013.103a1 1 0 00.995 1.098h9.471V35.21zM7.179 9.833c0-.173.141-.313.314-.313h.811c.173 0 .314.14.314.313v.305H7.179v-.305zm33.902.77c.935 0 1.696.76 1.696 1.696v23.215c0 .935-.761 1.696-1.696 1.696H3.696A1.698 1.698 0 012 35.514V12.299c0-.936.76-1.696 1.696-1.696h1.483v-.77A2.316 2.316 0 017.493 7.52h.811a2.316 2.316 0 012.314 2.313v.77h1.835v-.575A3.031 3.031 0 0115.481 7h13.816a3.032 3.032 0 013.028 3.028v.575h8.756zM22.388 29.928a6.606 6.606 0 01-6.599-6.6 6.606 6.606 0 016.6-6.597 6.606 6.606 0 016.598 6.598 6.606 6.606 0 01-6.599 6.599zm0-15.197c-4.74 0-8.599 3.857-8.599 8.598 0 4.742 3.858 8.599 8.6 8.599 4.74 0 8.598-3.857 8.598-8.6 0-4.74-3.858-8.597-8.599-8.597z","fill":"#1D1D1B","fill-rule":"evenodd"}})])
          )
        }
      }
    